<template>
  <section class="program-condition mb-5">
    <h6 class="mb-5 text-gray-700">Условия программы</h6>
    <div class="rounded border p-6 bg-white info-panel">
      <div class="row">
        <div v-if="this.module.ProgramCondition.infoBlock('av')"
            :class="!this.module.ProgramCondition.infoBlock('md') ? 'col-12' : 'col-6'">
          <div v-if="this.infoAgencyReward.av.type === 'input'" class="form-floating mb-5">
            <money3
                v-model.number="programCondition.av"
                v-bind="configAvMD"
                class="form-control form-control-solid mb-5"
                placeholder="АВ (гросс):"
                :disabled="this.infoAgencyReward.av.disabled"
                :class="!validate.av ? 'is-invalid' : ''"
                type="text"
                name="programCondition.av"
                id='programCondition.av'
            />
            <label for='programCondition.av'>АВ (гросс):</label>
          </div>
          <div v-else-if="this.infoAgencyReward.av.type === 'select'" class="form-floating mb-5">
            <select-field
                v-model="programCondition.av"
                :options="this.infoAgencyReward.av.dict"
                :disabled="this.infoAgencyReward.av.disabled"
                :class="!validate.av ? 'is-invalid' : ''"
                :mb="5"
                placeholder="АВ (гросс):"
                title="АВ (гросс):"
                name="programCondition.av"
                id="programCondition.av"
                :is-parse-int="false"
                />
          </div>
        </div>
        <div v-if="this.module.ProgramCondition.infoBlock('md')"
             :class="!this.module.ProgramCondition.infoBlock('av') ? 'col-12' : 'col-6'">
          <div v-if="this.infoAgencyReward.md.type === 'input'" class="form-floating mb-5">
            <money3
                v-model.number="programCondition.md"
                v-bind="configAvMD"
                class="form-control form-control-solid mb-5"
                placeholder="ПБ (гросс):"
                :disabled="this.infoAgencyReward.md.disabled"
                :class="!validate.md ? 'is-invalid' : ''"
                type="text"
                name="programCondition.md"
                id='programCondition.md'
            />
            <label for='programCondition.av'>ПБ (гросс):</label>
          </div>
          <div v-else-if="this.infoAgencyReward.md.type === 'select'" class="form-floating mb-5">
            <select-field
                v-model="programCondition.md"
                :options="Object.fromEntries(Object.entries(this.infoAgencyReward.md.dict).filter(([key]) => key < (this.infoAgencyReward.main.max - this.programCondition.av)))"
                :disabled="this.infoAgencyReward.md.disabled"
                :class="!validate.md ? 'is-invalid' : ''"
                :mb="5"
                placeholder="ПБ (гросс):"
                title="ПБ (гросс):"
                name="programCondition.md"
                id="programCondition.md"
                :is-parse-int="false"
            />
          </div>
        </div>
      </div>
      <select-field
          v-if="this.module.ProgramCondition.infoBlock('franchise')"
          v-model="programCondition.franchise"
          :options="this.franchises"
          :required="true"
          :disabled="changeDisabled"
          :mb="5"
          placeholder="Франшиза при повреждении"
          title="Франшиза при повреждении"
          name="form.franchise"
          id="form.franchise"
      />
      <slot name="otherOptions"></slot>
      <div v-if="this.module.ProgramCondition.infoBlock('insuredSum')" class="form-floating mb-5">
        <money3
            v-model.number="programCondition.insuredSum"
            v-bind="config"
            class="form-control form-control-solid"
            placeholder="Страховая сумма"
            :class="!validate.insuredSum ? 'is-invalid' : ''"
            disabled
            required
            type="text"
            name="programCondition.insuredSum"
            id='programCondition.insuredSum'
        />
        <label for='programCondition.insuredSum' class="required">Страховая сумма</label>
      </div>
      <slot name="riskBtn"></slot>
    </div>
  </section>
</template>

<script>
import {Money3Component} from 'v-money3'
import SelectField       from '@/components/Fields/SelectField'

export default {
  name: 'ProgramCondition',
  components: {SelectField, money3: Money3Component},
  props: {
    programCondition: null,
    role: null,
    isPerson: {
      type: Boolean,
      default: true
    },
    changeDisabled: {
      type: Boolean,
      default: false
    },
    module: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      franchises: this.module.ProgramCondition.infoBlock('franchise') ? this.module.ProgramCondition.infoFranchises().dict : null,
      validate: {
        av:         true,
        md:         true,
        franchise:  true,
        insuredSum: true
      },
      config: {
        decimal:    '.',
        thousands:  ' ',
        prefix:     '',
        suffix:     this.module.ProgramCondition.infoBlock('insuredSum') ? this.module.ProgramCondition.infoInsuredSum(this.isPerson).currency : ' ',
        precision:  2,
        masked:     false
      },
      configAvMD: {
        decimal:          '.',
        thousands:        ' ',
        prefix:           '',
        suffix:           ' ',
        precision:        2,
        masked:           false,
        disableNegative:  true,
      },
      infoAgencyReward: this.module.ProgramCondition.infoBlock('av') || this.module.ProgramCondition.infoBlock('md') ? this.module.ProgramCondition.infoAgencyReward(this.role) : null,
      infoInsuredSum: this.module.ProgramCondition.infoBlock('insuredSum') ? this.module.ProgramCondition.infoInsuredSum(this.isPerson) : null,
      infoFranchises: this.module.ProgramCondition.infoBlock('franchise') ? this.module.ProgramCondition.infoFranchises() : null
    }
  },
  mounted() {
    if (!this.$route.query.draft) {
      this.programCondition.av = this.module.ProgramCondition.infoBlock('av') ? (this.programCondition.av ? this.programCondition.av : this.infoAgencyReward.av.default) : 0
      this.programCondition.md = this.module.ProgramCondition.infoBlock('md') ? (this.programCondition.md ? this.programCondition.md : this.infoAgencyReward.md.default) : 0
      this.programCondition.franchise = this.module.ProgramCondition.infoBlock('franchise') ? (this.programCondition.franchise ? this.programCondition.franchise : this.infoFranchises.default) : null
    }
    if (this.programCondition.av === '0') this.programCondition.av = "0.00"
    if (this.programCondition.md === '0') this.programCondition.md = "0.00"
  },
  methods: {
    checkAv(val) {
      const def = this.infoAgencyReward.av.max
      const av = parseFloat(val)
      if (av > def) this.programCondition.av = def
      this.checkMd(this.programCondition.md)
    },
    checkMd(val) {
      const def = this.infoAgencyReward.md.max
      const defFull = def * 100
      const md = parseFloat(val)
      const av = parseFloat(this.programCondition.av)
      const mdFull = md * 100
      const avFull = av * 100
      if (this.infoAgencyReward.md.type === 'input') {
        if (mdFull > defFull) this.programCondition.md = this.infoAgencyReward.md.min
        if ((avFull + mdFull) > defFull) this.programCondition.md = def - av
      }
      if (this.infoAgencyReward.md.type === 'select') {
        let entries = Object.entries(this.infoAgencyReward.md.dict).filter(([key]) => key < (this.infoAgencyReward.main.max - this.programCondition.av));
        if (mdFull > defFull) this.programCondition.md = entries[entries.length-1][0]
        if ((avFull + mdFull) > defFull) this.programCondition.md = entries[entries.length-1][0]
      }
    },
  },
  watch: {
    programCondition: {
      deep: true,
      handler(val) {
        if (this.module.ProgramCondition.infoBlock('insuredSum'))
        this.validate.insuredSum = parseInt(val.insuredSum) <= this.infoInsuredSum.max

        if (this.module.ProgramCondition.infoBlock('av'))
        this.validate.av = parseFloat(val.av) <= this.infoAgencyReward.av.max
            && parseFloat(val.av) >= this.infoAgencyReward.av.min
            && parseFloat(val.av) + parseFloat(val.md) <= this.infoAgencyReward.main.max
            && parseFloat(val.av) + parseFloat(val.md) >= this.infoAgencyReward.main.min

        if (this.module.ProgramCondition.infoBlock('md'))
        this.validate.md = parseFloat(val.md) <= this.infoAgencyReward.md.max
            && parseFloat(val.md) >= this.infoAgencyReward.md.min
            && parseFloat(val.av) + parseFloat(val.md) <= this.infoAgencyReward.main.max
            && parseFloat(val.av) + parseFloat(val.md) >= this.infoAgencyReward.main.min
      }
    },
    'programCondition.av': {
      immediate: true,
      handler(val) {
        if (val)
          this.$nextTick(() => this.checkAv(val))
      }
    },
    'programCondition.md': {
      immediate: true,
      handler(val) {
        if (val)
          this.$nextTick(() => this.checkMd(val))
      }
    }
  }
}
</script>

<style scoped>

</style>